module.exports = __webpack_public_path__ + "static/media/sz.406966d9.svg";